import type React from 'react';

import Typography from '@mui/material/Typography';

import { useStyles } from 'components/tables/competitors/styles';

interface CompetitorsTableTitleProps {
  length: string;
  text: string;
}

const CompetitorsTableTitle: React.FC<React.PropsWithChildren<CompetitorsTableTitleProps>> = ({ length, text }) => {
  const { classes } = useStyles();
  return (
    <Typography variant="h1">
      {text} <span className={classes.titleSpan}>({length})</span>
    </Typography>
  );
};

export default CompetitorsTableTitle;
